import type { StoryNode } from '@year13/kui/components/KUI/Content/StoryAsset/storyAssetTypes';

import { isEndNodeType } from '~kui/components/KUI/Content/StoryAsset/utils/node';

const _endingNodes = ref<StoryNode[]>([]);
const _storyTitle = ref<string | null>(null);
const _skipCallback = ref<((nodeId: string) => void) | null>(null);

export const useStoryDevTools = () => {
  const registerStory = (
    story: { title: string; nodes: StoryNode[] },
    onSkipToEnding: (nodeId: string) => void,
  ) => {
    _endingNodes.value = story.nodes.filter(n => isEndNodeType(n.nodeType));
    _storyTitle.value = story.title;
    _skipCallback.value = onSkipToEnding;
  };

  const unregisterStory = () => {
    _endingNodes.value = [];
    _storyTitle.value = null;
    _skipCallback.value = null;
  };

  const skipToEnding = (nodeId: string) => {
    _skipCallback.value?.(nodeId);
  };

  return {
    storyTitle: readonly(_storyTitle),
    endingNodes: readonly(_endingNodes),
    hasActiveStory: computed(() => _endingNodes.value.length > 0),
    registerStory,
    unregisterStory,
    skipToEnding,
  };
};
